import * as $runtime from "../runtime.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Specular$dDom$dBuilder$dClass from "../Specular.Dom.Builder.Class/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
const triggerCallback = x => x;
const nullCallback = v => () => {};
const newCallback = dictMonadEffect => dictMonadEffect.Monad0().Bind1().Apply0().Functor0().map(v => ({event: v.event, callback: v.fire}))(Specular$dFRP$dBase.newEvent(dictMonadEffect));
const mkCallback = x => x;
const mbCallback = f => v1 => {
  if (v1.tag === "Nothing") { return () => {}; }
  if (v1.tag === "Just") {
    const $0 = f(v1._1);
    return () => {$0();};
  }
  $runtime.fail();
};
const dynCallback = dynCb => x => {
  const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(dynCb);
  return () => {
    const cb = $0();
    return cb(x)();
  };
};
const contramapCallbackEffect = f => cb => a => {
  const $0 = f(a);
  return () => {
    const $1 = $0();
    return cb($1)();
  };
};
const contramapCallbackDyn_ = fD => cb => v => {
  const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(fD);
  return () => {
    const f = $0();
    return cb(f)();
  };
};
const contramapCallbackDynMaybe = fD => cb => x => {
  const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(fD);
  return () => {
    const f = $0();
    const $1 = f(x);
    if ($1.tag === "Nothing") { return; }
    if ($1.tag === "Just") {
      cb($1._1)();
      return;
    }
    $runtime.fail();
  };
};
const contramapCallbackDyn = fD => cb => x => {
  const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(fD);
  return () => {
    const f = $0();
    return cb(f(x))();
  };
};
const attachEvent = dictMonadFRP => event => cb => Specular$dFRP$dBase.subscribeNode(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(cb)(event);
const attachDyn = dictMonadFRP => dyn => cb => Specular$dFRP$dBase.subscribeDyn_(dictMonadFRP)(cb)(dyn);
const attachDomEvent = dictMonadFRP => eventType => node => callback => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(Specular$dDom$dBuilder$dClass.domEventWithSample(dictMonadFRP)(Effect.pureE)(eventType)(node))(event => attachEvent(dictMonadFRP)(event)(callback));
export {
  attachDomEvent,
  attachDyn,
  attachEvent,
  contramapCallbackDyn,
  contramapCallbackDynMaybe,
  contramapCallbackDyn_,
  contramapCallbackEffect,
  dynCallback,
  mbCallback,
  mkCallback,
  newCallback,
  nullCallback,
  triggerCallback
};
